// libraries
import React from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import SectionDivider from '/react4xp/components/SectionDivider'
import Button from '/react4xp/components/Button'
import Input from '/react4xp/components/Form/Input'

// svg
import { GeneralSearch } from '/react4xp/components/Svg/Icons/General'

// utils
import { slugify } from '/lib/reactutils/utils'

// prop types
export interface OverviewTopPartProps {
    title?: string
    filters?: {
        id?: string
        name?: string
        title?: string
    }[]
    selectedFilters?: {
        id?: string
        name?: string
        title?: string
    }[]
    onFilterClick?: (filter: { id?: string; name?: string; title?: string }) => void
    search?: {
        label?: string
        searchButtonText?: string
        requiredText?: string
        value?: string
        onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
        onSearch?: () => void
		isLoading?: boolean
		disabled?: boolean
    }
}

export default function OverviewTopPart({
    title,
    filters = [],
    selectedFilters = [],
    onFilterClick,
    search
}: OverviewTopPartProps) {
	const handleSearchEnter = (event: React.KeyboardEvent<HTMLInputElement>) => {
		if (event.key === 'Enter' && search?.onSearch) {
			search.onSearch()
		}
	}

	const handleSearchButtonClick = () => {
		if (search?.onSearch) {
			search.onSearch()
		}
	}

	return (
        <>
            <Section className='overview-top-part'>
                <div className="container">

                    <h1 className='overview-top-part__title h1-hero-small'>
                        {title}
                    </h1>

                    {filters.length > 0 && (
                        <div className='overview-top-part__filters'>
                            {filters.map((filter, i) => (
                                <Button
                                    noUnderline
                                    key={i}
                                    onClick={() => onFilterClick?.(filter)}
                                    className={clsx(
                                        selectedFilters.some(selectedFilter => selectedFilter.id === filter.id) ? 'active' : ''
                                    )}
                                >
                                    {filter.title}
                                </Button>
                            ))}
                        </div>
                    )}

                    {search && (
                        <div className='overview-top-part__search'>
                            <Input
                                name={slugify(search?.label || 'search')}
                                id='search'
                                size='large'
                                label={search?.label}
                                type='text'
                                value={search?.value || ''}
                                onChange={search?.onChange}
                                onKeyDown={handleSearchEnter}
                            />

                            <Button
                                isSolid
                                noUnderline
								isLoading={search?.isLoading}
								disabled={search?.disabled}
                                onClick={handleSearchButtonClick}
                            >
                                {search?.searchButtonText}
                                <GeneralSearch variant='outline' />
                            </Button>
                        </div>
                    )}

                </div>
            </Section>

            <SectionDivider marginBottom='none' />

        </>
	)
}